module.exports = __webpack_public_path__ + "img/bg_nor.ddfa8f94.png";